
import { defineComponent, ref, onMounted, computed, onBeforeMount } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { MenuComponent } from "@/assets/ts/components";
export default defineComponent({
  name: "add-permission",
  props: ["id"],
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const submitButton = ref<HTMLElement | null>(null);
    let PERMISSIONS_DETAIL = ref([]);
    onMounted(async () => {
      await store.dispatch("GET_PERMISSIONS_DETAIL", props.id);
      PERMISSIONS_DETAIL.value = await store.getters["currentPermission"];
      setCurrentPageBreadcrumbs("Cập nhật quyền", ["Người dùng"]);
      MenuComponent.reinitialization();
    });
    const registration = Yup.object().shape({
      name: Yup.string().required("Quyền không được để trống"),
      module: Yup.string().required("Chức năng không được để trống"),
    });
    const onSubmitForm = (values) => {
      submitButton.value?.setAttribute("data-kt-indicator", "on");
      store
        .dispatch("UPDATE_PERMISSION", values)
        .then(() => {
          Swal.fire({
            text: "Cập nhật thông tin thành công",
            icon: "success",
            buttonsStyling: false,
            showCancelButton: true,
            confirmButtonText: "Danh sách",
            cancelButtonText: "Tiếp tục chỉnh sửa",
            customClass: {
              confirmButton: "btn fw-bold btn-light-success",
              cancelButton: "btn fw-bold btn-light-primary",
            },
          }).then(function (result) {
            // Go to page after successfully login
            if (result.isConfirmed) {
              router.push({ name: "permissions" });
            }
          });
        })
        .catch(() => {
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Thử lại!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
      submitButton.value?.removeAttribute("data-kt-indicator");
    };
    return {
      registration,
      onSubmitForm,
      PERMISSIONS_DETAIL,
    };
  },
});
